const comparison = () => {
    const comparisonFilters = document.querySelector(".comparison__filters");
    const comparisonForm = document.querySelector(".comparison__filters-form");
    const filtersWrap = document.querySelector(".comparison__filters-wrap");
    const filtersList = document.querySelector(".comparison__filters-list");
    const filtersBtn = document.querySelector(".comparison .filters__btn-show");
    const filtersBtnHide = document.querySelector(".comparison .filters__btn-hide");
    if (comparisonForm) {
        const checkboxes = comparisonForm.querySelectorAll(".comparison__checkbox[data-filter]");
        const checkboxesAll = comparisonForm.querySelector(".comparison__checkbox[data-all]");
        const parentElements = document.querySelectorAll(".comparison__selected, .comparison__item-properties");
        function setColors(parentElements) {
            for (let i = 0; i < parentElements.length; i++) {
                let elements = parentElements[i].querySelectorAll(".checked");
                for (let j = 0; j < elements.length; j++) {
                    if (j === 0 || j % 2 === 0) {
                        elements[j].classList.add("white");
                    }
                    else {
                        elements[j].classList.remove("white");
                    }
                }
            }
        }
        if (checkboxes) {
            let checkedAll = true;
            for (let i = 0; i < checkboxes.length; i++) {
                let elements = document.querySelectorAll(".comparison__selected-item[data-filter='" + checkboxes[i].dataset.filter + "'], .comparison__item-property[data-filter='" + checkboxes[i].dataset.filter + "']");
                for (let j = 0; j < elements.length; j++) {
                    if (checkboxes[i].checked) {
                        elements[j].classList.add("checked");
                    }
                    else {
                        elements[j].classList.remove("checked");
                        checkedAll = false;
                    }
                }
                if (checkedAll) {
                    checkboxesAll.checked = true;
                    checkboxesAll.parentElement.classList.add("all-selected");
                }
                else {
                    checkboxesAll.checked = false;
                    checkboxesAll.parentElement.classList.remove("all-selected");
                }
            }
            setColors(parentElements);
        }
        comparisonForm.addEventListener("change", function(e){
            if (e.target.dataset.hasOwnProperty("filter")) {
                let elements = document.querySelectorAll(".comparison__selected-item[data-filter='" + e.target.dataset.filter + "'], .comparison__item-property[data-filter='" + e.target.dataset.filter + "']");
                let checkedAll = true;
                for (let i = 0; i < elements.length; i++) {
                    if (e.target.checked) {
                        elements[i].classList.add("checked");
                    }
                    else {
                        elements[i].classList.remove("checked");
                    }
                }
                for (let i = 0; i < checkboxes.length; i++) {
                    if (!checkboxes[i].checked) {
                        checkedAll = false;
                    }
                }
                if (checkedAll) {
                    checkboxesAll.checked = true;
                    checkboxesAll.parentElement.classList.add("all-selected");
                }
                else {
                    checkboxesAll.checked = false;
                    checkboxesAll.parentElement.classList.remove("all-selected");
                }
            }
            if (e.target.dataset.hasOwnProperty("all")) {
                for (let i = 0; i < checkboxes.length; i++) {
                    if (e.target.checked) {
                        checkboxes[i].checked = true;
                    }
                    else {
                        checkboxes[i].checked = false;
                    }
                    let elements = document.querySelectorAll(".comparison__selected-item[data-filter='" + checkboxes[i].dataset.filter + "'], .comparison__item-property[data-filter='" + checkboxes[i].dataset.filter + "']");
                    for (let j = 0; j < elements.length; j++) {
                        if (e.target.checked) {
                            elements[j].classList.add("checked");
                        }
                        else {
                            elements[j].classList.remove("checked");
                        }
                    }
                }
                if (e.target.checked) {
                    checkboxesAll.parentElement.classList.add("all-selected");
                }
                else {
                    checkboxesAll.parentElement.classList.remove("all-selected");
                }
            }
            setColors(parentElements);
        });
    }
    if (filtersBtn) {
        filtersBtn.addEventListener("click", function(e){
            if (filtersWrap && filtersList) {
                filtersWrap.classList.add("open");
                comparisonFilters.classList.add("open");
            }
        });
    }
    if (filtersBtnHide) {
        filtersBtnHide.addEventListener("click", function(e){
            if (filtersWrap && filtersList) {
                filtersWrap.classList.remove("open");
                comparisonFilters.classList.remove("open");
            }
        });
    }
}
export default comparison;
